import pluralize from 'pluralize';

import { PAGES } from './routes';

export const SCHEDULE_LIMIT = 90; // days

export const PAGE_SIZE = 5;

export const DAYS_SPAN = 14;

export const TODAY = 'today';

export const TIMER = {
  COMPLETE: 'complete',
  SOON: 'soon',
  NOT_SO_SOON: 'not-so-soon',
};

export const SCHEDULE_ACTION = {
  CANCEL: 'cancel',
  RESCHEDULE: 'reschedule',
  SCHEDULE: 'schedule',
};

export const SCHEDULE = {
  LISTINGS: 'listings',
  UPDATES: 'updates',
};

export const SCHEDULE_PAGE = {
  [SCHEDULE.LISTINGS]: PAGES.SCHEDULE_LISTINGS,
  [SCHEDULE.UPDATES]: PAGES.SCHEDULE_UPDATES,
};

export const SCHEDULE_TYPES = [
  SCHEDULE.LISTINGS,
  SCHEDULE.UPDATES,
];

export const SCHEDULE_TYPE_NAME = {
  [SCHEDULE.LISTINGS]: 'Listings',
  [SCHEDULE.UPDATES]: 'Updates',
};

export const SCHEDULE_TYPE_API_KEY = {
  [SCHEDULE.LISTINGS]: 'scheduled_listings_count',
  [SCHEDULE.UPDATES]: 'scheduled_updates_count',
};

export const TABLE_ROW = {
  DATE: 'date',
  HEAD: 'head',
  LISTING: 'listing',
  LOADER: 'loader',
  UPDATE: 'update',
};

export const TABLE_ROW_SIZE = {
  [TABLE_ROW.DATE]: 58,
  [TABLE_ROW.HEAD]: 33,
  [TABLE_ROW.LISTING]: 80,
  [TABLE_ROW.LOADER]: 80,
  [TABLE_ROW.UPDATE]: 66,
};

export const TABLE_COLUMN = {
  CHECKBOX: 'checkbox',
  CONTROLS: 'controls',
  COUNTDOWN: 'countdown',
  CREATED: 'created',
  LISTINGS: 'listings',
  SCHEDULED: 'scheduled',
  SHOPS: 'shops',
  TITLE: 'title',
  UPDATES: 'updates',
};

export const ERRORS = {
  SCHEDULED_OVER_LIMIT: `Scheduled date should be less than ${pluralize('day', SCHEDULE_LIMIT, true)} from now`,
  SCHEDULED_IN_PAST: 'Scheduled time is in the past',
};
